import { z } from '@hono/zod-openapi'

export const updateDeviceTokenRequestSchema = z
  .object({
    deviceToken: z.string().min(1).nullable().optional(),
    deviceIdentifierHash: z
      .string()
      .regex(/^[0-9a-f]{64}$/)
      .optional(),
    os: z.enum(['ios', 'android']).optional(),
    permissionStatus: z.enum(['granted', 'undetermined', 'denied']).optional(),
  })
  .refine(
    ({ deviceToken, deviceIdentifierHash, os, permissionStatus }) => {
      const hasNoMetadata = deviceIdentifierHash === undefined && os === undefined && permissionStatus === undefined
      const hasFullMetadata = deviceIdentifierHash !== undefined && os !== undefined && permissionStatus !== undefined

      return hasFullMetadata || (hasNoMetadata && typeof deviceToken === 'string' && deviceToken.length > 0)
    },
    { message: 'deviceToken 또는 deviceIdentifierHash, os, permissionStatus 전체가 필요합니다.' },
  )

export type UpdateDeviceTokenRequest = z.infer<typeof updateDeviceTokenRequestSchema>
